import InsideDrawer, { IDrawerSettings } from '@src/shared/components/InsideDrawer';
import { DrawerType, useInsideDrawerActions } from '@src/shared/context/inside-drawer';
import React from 'react';
import companyLogo from '@assets/logo-just-eat-takeaway-corporate-logo-orange-rgb.svg';
import styles from './MobileNavigationDrawer.module.scss';
import { IconClose, IconLinkExternal } from '@justeattakeaway/pie-icons-react';
import MobileNavigationDrawerTextNavLink from './components/MobileNavigationDrawerTextNavLink';
import { useTranslation } from 'react-i18next';
import useFMFeatureFlag from '@src/shared/hooks/use-fm-featureflag';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import { JETFM_SHOW_NEW_DASHBOARD } from '@src/shared/models';
import i18n, { languageQueryParam } from '@src/i18n';
import MCPMarketEnvironmentDetection from '@src/shared/utils/market-environment-detection';
const drawerSettings: IDrawerSettings = {
  anchor: 'left',
  fullSize: true,
  customClose: true,
  drawerVariant: 'temporary',
};

const MobileNavigationDrawerContent = () => {
  const { t } = useTranslation();
  const showNewDashboard = useFMFeatureFlag(JETFM_SHOW_NEW_DASHBOARD);
  const { keycloakToken } = useKeycloakUserState();
  const isUserLoggedIn = !!keycloakToken;
  const { setDrawerFlush } = useInsideDrawerActions();
  const marketEnvironment = MCPMarketEnvironmentDetection.getMarketEnvironment();
  const partnerHubURL = PARTNER_HUB_URLS[marketEnvironment.countryCode] || '';
  const renderLoggedInUserLinks = () => {
    return (
      <>
        <MobileNavigationDrawerTextNavLink
          to={'/deliveries'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {t('navigation.deliveries')}
        </MobileNavigationDrawerTextNavLink>
        <MobileNavigationDrawerTextNavLink
          to={'/couriers'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {t('navigation.couriers')}
        </MobileNavigationDrawerTextNavLink>

        {/*         {showNewDashboard && (
          <MobileNavigationDrawerTextNavLink
            to={'/delivery-dashboard'}
            className={styles.navItem}
            activeClassName={styles.navItemActive}
          >
            {'New Delivery Dashboard'}
          </MobileNavigationDrawerTextNavLink>
        )} */}

        <MobileNavigationDrawerTextNavLink
          to={'/product-overview'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
          isActive={() =>
            location.pathname.includes('courier-overview') ||
            location.pathname.includes('product-overview')
          }
        >
          {t('mobile.product_overview')}
        </MobileNavigationDrawerTextNavLink>
        <MobileNavigationDrawerTextNavLink
          to={`${partnerHubURL}/?${languageQueryParam}=${i18n.language}`}
          external={true}
          className={`${styles.navItem} ${styles.partnerhublink}`}
          activeClassName={styles.navItemActive}
        >
          {t('navigation.partner_hub')} <IconLinkExternal size={'s'} />
        </MobileNavigationDrawerTextNavLink>
      </>
    );
  };

  const renderLoggedOutUserLinks = () => {
    return (
      <>
        <MobileNavigationDrawerTextNavLink
          to={'/product-overview'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {'Manager'}
        </MobileNavigationDrawerTextNavLink>
        <MobileNavigationDrawerTextNavLink
          to={'/courier-overview'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {'Courier'}
        </MobileNavigationDrawerTextNavLink>
        <MobileNavigationDrawerTextNavLink
          to={'/deliveries'}
          external={true}
          className={`${styles.navItem}`}
          activeClassName={styles.navItemActive}
        >
          Courier Portal <IconLinkExternal size={'s'} />
        </MobileNavigationDrawerTextNavLink>
      </>
    );
  };

  return (
    <InsideDrawer
      onClose={setDrawerFlush}
      titleI18nKey=""
      settings={drawerSettings}
      type={DrawerType.MOBILE_NAVIGATION}
    >
      <div className={styles.MobileNavigationDrawerContent}>
        <div className={styles.MobileNavigationDrawerContentHeader}>
          <img src={companyLogo} />
          <IconClose
            size="l"
            onClick={() => {
              setDrawerFlush();
            }}
          />
        </div>
        <div>{isUserLoggedIn ? renderLoggedInUserLinks() : renderLoggedOutUserLinks()}</div>
      </div>
    </InsideDrawer>
  );
};

export default MobileNavigationDrawerContent;
